var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconPaleoColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A0B3C9",
    d: "M13.858 9.452l5.607-5.608-.206-.232a1.964 1.964 0 01-.509-1.31c0-1.088.886-1.973 1.974-1.973.981 0 1.818.739 1.946 1.718l.033.25.25.033a1.972 1.972 0 011.718 1.946 1.976 1.976 0 01-1.974 1.974c-.477 0-.942-.18-1.309-.509l-.232-.207-5.608 5.608-1.69-1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0B3C9",
    d: "M20.724.658c.816 0 1.513.615 1.62 1.431l.066.502.501.066a1.642 1.642 0 011.431 1.62c0 .906-.737 1.644-1.645 1.644a1.62 1.62 0 01-1.09-.425l-.464-.414-.44.44-5.155 5.155-1.225-1.225 5.155-5.155.44-.44-.414-.464a1.62 1.62 0 01-.425-1.09c0-.907.737-1.645 1.645-1.645zm0-.658a2.303 2.303 0 00-2.303 2.303c0 .59.228 1.12.592 1.529l-5.62 5.62 2.155 2.155 5.62-5.62c.408.364.94.592 1.53.592a2.296 2.296 0 10.299-4.575A2.296 2.296 0 0020.723 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCD5F2",
    stroke: "#8B75A1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.071 16.071l7.942 7.942"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A16A4A",
    d: "M5.014 19.186L.89 13.596c.987-1.11 6.408-6.687 15.53-6.688-.008.003.654.122 1.101.569.458.459.572 1.143.573 1.15-.003 8.68-5.556 14.407-6.679 15.476l-6.402-4.917z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A16A4A",
    d: "M16.363 7.237c.136.03.607.152.927.473.322.322.444.791.473.927-.024 8.118-4.942 13.606-6.372 15.031l-6.14-4.715-3.935-5.337c1.315-1.413 6.522-6.355 15.046-6.38zm.061-.658c-10.369 0-15.953 7-15.953 7l4.306 5.839 6.66 5.114s6.984-6.036 6.984-15.957c0 0-.12-.786-.666-1.33-.544-.546-1.33-.666-1.33-.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F78F8F",
    d: "M10.052 24.671c-1.665 0-4.111-1.37-6.232-3.491C.974 18.334-.44 14.937.736 13.762c.27-.27.669-.407 1.185-.407 1.665 0 4.111 1.37 6.232 3.492 1.434 1.433 2.535 3.02 3.102 4.467.524 1.34.518 2.416-.017 2.95-.27.27-.67.407-1.186.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A16A4A",
    d: "M1.921 13.684c1.558 0 3.968 1.365 6 3.396 1.401 1.402 2.476 2.948 3.027 4.354.468 1.195.489 2.166.057 2.598-.206.206-.527.31-.952.31-1.558 0-3.969-1.364-6-3.395C1.181 18.074.056 14.907.97 13.995c.205-.206.526-.31.952-.31zm0-.658c-.588 0-1.076.162-1.418.504-1.325 1.325.056 4.854 3.084 7.882C5.836 23.66 8.36 25 10.053 25c.588 0 1.076-.162 1.417-.503 1.325-1.325-.056-4.854-3.084-7.883-2.248-2.248-4.77-3.588-6.465-3.588z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCD5F2",
    stroke: "#8B75A1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.276 4.276l6.58 6.58"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8B75A1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.598 4.93c-1.156 0-2.03-.21-2.4-.58-.551-.551-.96-2.287-1.14-3.295 1.002.179 2.731.583 3.292 1.144.553.553.612 1.965.578 2.726a9.265 9.265 0 01-.33.006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.471 1.468c1.067.221 2.264.58 2.647.963.363.364.494 1.348.49 2.171h-.01c-1.037 0-1.868-.186-2.166-.484-.377-.377-.737-1.577-.96-2.65zM.658.658s.442 3.06 1.308 3.925c.582.581 1.857.677 2.632.677.38 0 .639-.023.639-.023s.226-2.39-.654-3.271C3.703 1.086.658.658.658.658z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.058 18.532c-.291.29.012 1.066.678 1.732.666.666 1.441.97 1.733.678.29-.29-.013-1.067-.679-1.732-.665-.666-1.441-.97-1.732-.678z"
  }))));
}

export default SvgCommonIconPaleoColor;